module.exports = __webpack_public_path__ + "img/restaurant_2.c89509f6.jpg";